module.exports = __webpack_public_path__ + "img/Loverly_Preview_GuestList.9224ad4.jpg";